import { UserInfoBoxTitle, UserBoxWrapper } from "./UserDialogUi";

function BalanceInfo({ userData }) {
  return (
    <UserBoxWrapper>
      <UserInfoBoxTitle title="Balance Info" />
      <div className="bg-gray-100 m-2 p-4 rounded-md max-lg:text-sm">
        <div className="flex justify-between border-b-1 border-dBlue-100 pb-2">
          <p>Cash Balance</p>
          <p>₹{userData.cashBalance}</p>
        </div>
        <div className="flex justify-between border-b-1 border-dBlue-100 pb-2 pt-2">
          <p>Account Balance</p>
          <p>₹{userData.accountBalance}</p>
        </div>
        <div className="flex justify-between pt-2 text-sm text-sec-blue font-interBold">
          <p>Total Balance</p>
          <p>₹{userData.totalBalance}</p>
        </div>
      </div>

      <div className="flex justify-between p-2 bg-gray-100 m-2 rounded-md max-lg:text-sm">
        <p>Pending Balance</p>
        <p>₹{userData.pendingBalance}</p>
      </div>
      <div className="flex justify-between p-2 bg-gray-100 m-2 rounded-md max-lg:text-sm">
        <p>Loan Balance</p>
        <p>₹{userData.loanBalance}</p>
      </div>
    </UserBoxWrapper>
  );
}

export default BalanceInfo;
